type FeatureFigureProps = {
  src: string;
  caption: string;
};

export function FeatureFigure({ src, caption }: FeatureFigureProps) {
  return (
    <figure>
      <a href={src} target={'_blank'} rel={'noreferrer'}>
        <img src={src} alt={caption} />
      </a>
      <figcaption className="caption">{caption}</figcaption>
    </figure>
  );
}
